import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSmartphone = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 17.4H12.0086M7.71429 3H16.2857C17.2325 3 18 3.80589 18 4.8V19.2C18 20.1941 17.2325 21 16.2857 21H7.71429C6.76751 21 6 20.1941 6 19.2V4.8C6 3.80589 6.76751 3 7.71429 3Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSmartphone);
export { ForwardRef as ReactComponent };
